import { render, staticRenderFns } from "./ShipmentItem.vue?vue&type=template&id=bf106066&scoped=true&lang=pug"
import script from "./ShipmentItem.vue?vue&type=script&lang=js"
export * from "./ShipmentItem.vue?vue&type=script&lang=js"
import style0 from "./ShipmentItem.vue?vue&type=style&index=0&id=bf106066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf106066",
  null
  
)

export default component.exports